import styled from 'styled-components'

interface IExporterProcessingStatusStyledProps {}

export const ExporterProcessingStatusStyled = styled.div<IExporterProcessingStatusStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: 0 4em;

  .export-filters-table {
    width: ${(props) => props.theme.typography.pxToRem(400)};

    margin: 0 auto;

    th,
    td {
      width: 50%;
      padding: 0em 0.5em;
    }

    th {
      text-align: right;
    }

    td {
      text-align: left;
    }
  }
`
